import React from 'react';
import { Grid } from '@mui/material';
import { Customer } from '../../../models/customer.model';
import CustomerContactCard from '../../../common/customer-contact-card/CustomerContactCard';

interface ContactsTabsProps {
  customer?: Customer;
  companyId: number;
  key: string;
}

const ContactsTabs: React.FC<ContactsTabsProps> = ({ customer, companyId }) => {
  const contacts = customer?.contacts || [];

  return (
    <>
      <Grid component='div' container wrap='wrap' style={{ rowGap: '16px' }}>
        <Grid
          component='div'
          size={{ xs: 12 }}
          container
          spacing={2}
          sx={{ flexDirection: 'column' }}
        >
          {contacts.length > 0 &&
            contacts.map((contact) => (
              <Grid component='div' key={contact.id}>
                <CustomerContactCard contact={contact} companyId={companyId} />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default ContactsTabs;
